module.exports = __webpack_public_path__ + "img/resume-builder.b7348669.svg";